module.exports = __webpack_public_path__ + "static/media/l_2_8.9e16bc19.png";